import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { ListItem, ListItemText } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DragItem from "../drag-item";

const FileListItem = ({ itemObject, index }) => {
  const theme = useTheme();
  const { setNodeRef, isOver } = useDroppable({
    id: itemObject.id,
    data: { type: "file-slot", index }
  });

  return (
    <ListItem sx={{ display: "flex", pr: 0, pl: 0 }} component="div">
      <ListItemText
        sx={{ width: "44%", paddingRight: "1%" }}
        primaryTypographyProps={{ style: { textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" } }}
        primary={itemObject.columnName || "(empty)"}
      />
      <div
        ref={setNodeRef}
        data-testid={`import-file-slot-${index}`}
        style={{
          width: "55%",
          minHeight: "32px",
          backgroundColor: isOver ? theme.palette.primary.main : undefined,
          border: "1px solid lightgrey"
        }}
      >
        {itemObject.token ? <DragItem token={itemObject.token} /> : null}
      </div>
    </ListItem>
  );
};

export default FileListItem;
